import { FC } from "react";
import { makeSxStyles } from "ui";
import NavbarMenuButton from "./navbar-menu-button";
import { AppBar, Box, Toolbar } from "@mui/material";
import useRole from "../../hooks/use-role";
import { IMPERSONATION_BANNER_HEIGHT } from "../../constants/layout";

export interface NavbarProps {
  showAccountMenu?: boolean;
  children?: React.ReactNode;
}

const Navbar: FC<NavbarProps> = (props) => {
  const { showAccountMenu, children } = props;
  const { isImpersonating } = useRole();
  const styles = useStyles();

  return (
    <Box sx={styles.container}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          ...styles.appBar,
          top: isImpersonating ? `${IMPERSONATION_BANNER_HEIGHT}px` : 0,
        }}
      >
        <Toolbar>
          <img src="/snowsync-logo.png" alt="logo" style={{ width: "150px" }} />
          {children}
          {showAccountMenu && <NavbarMenuButton />}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

const useStyles = makeSxStyles(
  ({
    palette: {
      background: { paper },
    },
  }) => ({
    container: {
      flexGrow: 1,
    },
    appBar: {
      background: paper,
    },
    img: {
      width: "200px",
    },
    link: {
      marginLeft: "10px",
      cursor: "pointer",
    },
  }),
);

export default Navbar;
